import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPortal } from "react-dom";
import SVG_CashoutIcon from "../../assets/images/svgs/cashout.svg?react";
import { setIsCashOutPopup } from "../../store/cashoutPopup/cashoutPopup.slice";
import { toastr } from "react-redux-toastr";
import { connectCashoutPopup } from "./CashoutPopup.connect";
const modalRoot = document.querySelector("#modal-root");

const CashoutPopup = ({ betPlacing, actions }) => {
  const dispatch = useDispatch();
  const cashoutPopup = useSelector((state) => state.cashoutPopUp);

  const [isPlacing, setPlacing] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (timer && isPlacing) {
      const time = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);
      return () => clearInterval(time);
    }
  }, [timer, isPlacing]);

  useEffect(() => {
    setTimer(betDelayLoader());
  }, [isPlacing]);

  function betDelayLoader() {
    let betDelay = 0;
    if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "4"
    ) {
      //Match Odds Cricket
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.matchoddsBetDelay || 5,
      );
    } else if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "1"
    ) {
      // Match Odds Football
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.soccerBetDelay || 5);
    } else if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "2"
    ) {
      // Match Odds Tennis
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.tennisBetDelay || 5);
    } else if (cashoutPopup?.market.marketType == "Special") {
      // Bookmaker
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.bookmakerBetDelay || 5,
      );
    } else if (cashoutPopup?.market.marketType == "SESSION") {
      // Session
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.fancyBetDelay || 5);
    } else if (cashoutPopup?.market.eventTypeId == "v9") {
      // Virtual
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.virtualBetDelay || 5);
    } else if (cashoutPopup?.market.eventTypeId == "b9") {
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.ballbyballBetDelay || 5,
      );
    } else {
      betDelay = 5;
    }
    return betDelay;
  }

  const submit = async () => {
    setPlacing(true);
    actions.setBetPlacingPopoverStage(true);
    actions
      .requestSetOrder(betPlacing)
      .then((res) => {
        if (res?.data) {
          if (res?.data?.status) {
            toastr.success("", "Cash-out successful");
            actions.setIsCashOut(false);
            actions.setCashOutId(null);
          } else {
            toastr.error("", res?.data?.msg);
          }
        }
        actions.requestOpenBets();
        actions.requestUnMatchedBets();

        actions.setShowBetPlacingPopover(false);
        actions.setMarket();
        // cancel()
        setPlacing(false);
        dispatch(setIsCashOutPopup({ isOpen: false, market: null }));
      })
      .catch((e) => {
        // cancel()
        actions.setShowBetPlacingPopover(false);
        setPlacing(false);
        actions.setMarket();
        dispatch(setIsCashOutPopup({ isOpen: false, market: null }));
        if (e[0] && e[0][0] && e[0][0].msg) toastr.error("", e[0][0].msg);
        else toastr.error("", e?.msg);
      });
  };

  console.log("betPlacing", betPlacing);

  // is_back: betPlacing.isBack ? 1 : 0,
  // market_id: betPlacing.market,
  // odds: betPlacing.priceActual,
  // selection_id: betPlacing.runner,
  // stack: Number(betPlacing.stake),

  return createPortal(
    <>
      {cashoutPopup?.isOpen && (
        <div
          id="popup-modal"
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh]     items-center justify-center  bg-bg_CasinoPopupBg"
        >
          <div className="relative w-[95%] max-w-lg bg-bg_color_primary flex justify-start overflow-y-auto flex-col rounded-lg p-3 font-lato gap-y-3 overflow-hidden popUpOpenAnimation1">
            <div className=" flex flex-col gap-1 align-top items-center gap-y-5 text-[14px]">
              <div className="flex flex-col items-center text-start gap-3 w-full max-w-full">
                <header className="w-full shrink-0" role="banner">
                  <h2
                    className="text-lg font-bold text-start tracking-tight min-w-0 text-text_color_primary1 font-lato"
                    aria-label="Cash out: Lay bet on Scotland"
                  >
                    {betPlacing.isBack ? "Back" : "Lay"} on{" "}
                    {betPlacing?.runnerName}
                  </h2>
                </header>
                <div className="w-full antialiased">
                  <div
                    className="rounded-lg border border-ternary6 overflow-hidden mb-3 shadow-sm transition-colors font-semibold font-lato bg-bg_color_layBtnBg hover:opacity-95"
                    role="region"
                    aria-label="Cash out offer: Lay on Scotland, price and stake"
                    title="Your cash out offer: Lay — price and stake"
                  >
                    <span className="sr-only">
                      Cash out offer: price and stake for this bet.
                    </span>
                    <div
                      className="grid grid-cols-2 gap-4 px-3 py-2 border-b border-ternary6 text-sm font-semibold text-text_color_tertiary4 text-center bg-bg_color_layBtnBg/90"
                      role="row"
                      aria-label="Offer price and stake labels"
                    >
                      <span role="columnheader">Price</span>
                      <span role="columnheader">Stake</span>
                    </div>
                    <div
                      className="grid grid-cols-2 gap-4 px-3 py-3 items-center text-base font-semibold tabular-nums text-text_color_oddValue text-center"
                      role="row"
                    >
                      <span role="cell" title="Cash out price: 28">
                        {betPlacing?.priceActual}
                      </span>
                      <span role="cell" title="Cash out stake: 97.66">
                        {betPlacing.stake}
                      </span>
                    </div>
                  </div>
                  <div
                    className="border rounded-md px-2 py-1.5 text-sm font-medium  font-lato text-[#0288d1] border-ternary6"
                    role="note"
                    aria-label="Minimum stake required for cash out. Operation will not succeed below minimum stakes."
                    title="Cash out has a minimum stake requirement"
                  >
                    <div className="flex items-start gap-1.5">
                      <svg
                        className="h-3.5 w-3.5 mt-0.5 flex-shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <p
                        className="leading-tight"
                        title="Cash out will not succeed below the minimum stake."
                      >
                        <span className="font-semibold">Note:</span> Operation
                        will not succeed below minimum stakes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <span className=" text-text_Ternary  font-[450]">
                <SVG_CashoutIcon />
              </span> */}
              {/* <span className=" text-text_Ternary  font-medium font-lato leading-4 text-sm">
                Do you wish to perform cash out?
              </span> */}
              <div className=" grid grid-cols-2 w-full gap-x-2">
                <button
                  type="button"
                  className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  bg-transperent w-full px-2.5 py-1 border-[1px] border-primary rounded-[4px] flex items-center justify-center  cursor-pointer "
                  onClick={() => {
                    setPlacing(false);
                    actions.setMarket();
                    dispatch(
                      setIsCashOutPopup({ isOpen: false, market: null }),
                    );
                  }}
                >
                  <span className="text-text_Primary text-[16px] font-[700] font-lato ">
                    Cancel
                  </span>
                </button>
                <div className="w-full">
                  <button
                    type="button"
                    className="  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  bg-cashout-btn-gradient w-full h-[36px] min-h-[36px]  px-2.5 py-1 border-[1px] border-success rounded-[4px] flex items-center justify-center  cursor-pointer"
                    onClick={() => {
                      submit();
                    }}
                  >
                    <span className="text-text_Quaternary text-[16px] font-[700] font-lato ">
                      Cashout
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {isPlacing && (
            <div className="z-3 popUpBoxShadow popUpOpenAnimation  absolute  w-[95%] max-w-[350px] z-[900] bg-bg_Quaternary p-2 xs:p-5  rounded-md">
              <div className=" flex flex-col gap-1 align-top items-center ">
                <span className=" relative w-max min-w-6 min-h-6 flex items-center justify-center p-2 pt-6 ">
                  <span className=" absolute min-w-14 min-h-14 animate-spin rounded-full border-[2px] border-primary border-dashed"></span>
                  <span className="font-semibold text-text_Ternary ">
                    {timer}
                  </span>
                </span>
                <span className=" font-semibold mt-[4px]">
                  Your cashout is being processed...
                </span>
                <span className=" font-semibold">Please Wait...</span>
              </div>
            </div>
          )}
        </div>
      )}
    </>,
    modalRoot,
  );
};

export default connectCashoutPopup()(CashoutPopup);
